import axios from "axios";

// webserver config
let APIURL = `${location.protocol}//${location.host}/${process.env.PSEO_API_ENDPOINT}/`;
// use the hardcoded root API url if provided at build
if (process.env.PSEO_API_ROOT_URL) {
  APIURL = `${process.env.PSEO_API_ROOT_URL}/${process.env.PSEO_API_ENDPOINT}`;
}

export const getEarningsMetadataQuery = () => {
  return {
    query: `
      {
        earnings_availability {
          institution_statefips
          institution_statefips_label
          institutions {
            institution
            institution_label
            degree_levels {
              degree_level
              degree_level_label
              grad_cohorts {
                grad_cohort_id
                grad_cohort_label
                grad_cohort
                grad_cohort_years_avail
              }
            }
          }
        }
      }
      `,
  };
};

export const getEarningsDegreeCountQuery = (
  institution,
  degree_level,
  grad_cohort_id
) => {
  return {
    query: `{
      earnings_degreecount(
        institution: "${institution}"
        degree_level: "${degree_level}"
        grad_cohort_id: "${grad_cohort_id}"
      )
      {
        cipcode
        cipcode_label
        cip_level
        y1_grads
        y5_grads
        y10_grads
        max_grads
      }
    }
    `,
  };
};

export const getEarningsDataQuery = (
  institution,
  degree_level,
  grad_cohort_id
) => {
  return {
    query: `{
      earnings_data(
        institution: "${institution}"
        degree_level: "${degree_level}"
        grad_cohort_id: "${grad_cohort_id}"
      )
      {
        cipcode
        cipcode_label
        y1_p25_earnings
        y1_p50_earnings
        y1_p75_earnings
        y1_grads_earn
        y5_p25_earnings
        y5_p50_earnings
        y5_p75_earnings
        y5_grads_earn
        y10_p25_earnings
        y10_p50_earnings
        y10_p75_earnings
        y10_grads_earn
      }
    }
    `,
  };
};

export const getFlowsDegreeCountQuery = (
  institution,
  degree_level,
  grad_cohort_id
) => {
  return {
    query: `{
      flows_degreecount(
        institution: "${institution}"
        degree_level: "${degree_level}"
        grad_cohort_id: "${grad_cohort_id}"
      )
      {
        cipcode
        cipcode_label
        cip_level
        y1_grads
        y5_grads
        y10_grads
        max_grads
      }
    }
    `,
  };
};

export const getFlowsDataQuery = (
  institution,
  degree_level,
  grad_cohort_id
) => {
  return {
    query: `{
      flows_data(
        institution: "${institution}"
        degree_level: "${degree_level}"
        grad_cohort_id: "${grad_cohort_id}"
      )
      {
        cipcode
        cipcode_label
        industry
        industry_label
        geography
        geography_label
        y1_grads_emp
        y1_grads_emp_instate
        y5_grads_emp
        y5_grads_emp_instate
        y10_grads_emp
        y10_grads_emp_instate
        y1_grads_nme
        y5_grads_nme
        y10_grads_nme
      }
    }
    `,
  };
};

export const getFlowsMetadataQuery = () => {
  return {
    query: `
      {
        flows_availability{
          institution_statefips
          institution_statefips_label
          institutions{
            institution
            institution_label
            degree_levels{
              degree_level
              degree_level_label
              grad_cohorts{
                grad_cohort_id
                grad_cohort_label
                grad_cohort
                grad_cohort_years_avail
              }
            }
          }
        }
      }
      `,
  };
};

export const performQuery = async (query) => {
  let result = await axios.post(APIURL, query);
  return result.data;
};
